<template>
  <div :class="{'artist-card-profile': isProfile}" class="artist-card relative flex pointer pa3 cover bg-center resize">
    <div class="flex-column w-100">
      <router-link class="artist-info" :to="{ name:'playlist', params:{ id: playlist.id }}">
        <!-- llamar a playlist->profile , ya q playlistProfile -> playlistTracl -->
        <div class="h-100 w-100 flex">
          <div class="pointer h-100 flex flex-column bg-primary minH-220">
            <div class="fl ma0 items-center justify-between">
              <div class="image-playlist-container">
                <img class="image-playlist-container" :src="playlistPicture" :alt="`${playlist.title} Picture`">
              </div>
            </div>
            <p class="playlist-card-container title fl h-100 pa1 pr3 ma0 text-ellipsis center-content textColor">{{ playlist.title }}</p>
            <p class="playlist-card-container genre fl h-100 pa1 ma0 text-ellipsis center-content textColor">{{ playlist.user.user_name }}</p>
            <button v-if="!isMyPlaylists" @click="likePlaylist()" class="like-button pa2 iconColor" :title="$t('playlists.like.button')">
              <font-awesome-icon :class="liking ? 'liked' : 'iconColor'" icon="heart"/>
            </button>
          </div>
        </div>
      </router-link>
    </div>
  </div>
</template>

<script>
  import TrackData from '@/components/tracks/TrackData'
  import consts from '@/consts'
  import {mapGetters, mapActions} from 'vuex'
  import FontAwesomeIcon from '@fortawesome/vue-fontawesome'
  import SimpleTracksList from '@/components/tracks/SimpleTracksList.vue'

  export default {
    name: 'modal-playlist-card',
    props: {
      playlist: {
        default: null
      },
      isPlaylistList: {
        default: false
      },
      isProfile: {
        default: false
      }
    },
    data () {
      return {
        liking: null
      }
    },
    components: {
      TrackData,
      FontAwesomeIcon,
      SimpleTracksList
    },
    computed: {
      playlistPicture () {
        if (this.playlist.picture) {
          return consts.MEDIA_BASE_URL + this.playlist.picture
        } else {
          return consts.BASE_HOST + '/static/assets/Img_comodines_Beathey_Playlist.jpg'
        }
      },
      ...mapGetters('player', [
        'isPlaying'
      ]),
      ...mapGetters('user', [
        'myPlaylists',
        'user'
      ]),
      ...mapGetters('playlist', [
        'playlistLiked'
      ]),
      ...mapGetters('playlist', {
        selectedPlaylist: 'playlist'
      }),
      isMyPlaylist () {
        return this.user && this.playlist.user.id === this.user.id
      },
      picture () {
        if (this.playlist.picture) {
          return consts.MEDIA_BASE_URL + this.playlist.picture
        } else {
          return '/static/assets/Img_comodines_Beathey_Playlist.jpg'
        }
      }
    },
    methods: {
      ...mapActions('player', [
        'setPlaylist',
        'changeTrack',
        'playFirstTrack'
      ]),
      ...mapActions('playlist', [
        'delete',
        'togglePlaylistLike'
      ]),
      deletePlaylist () {
        this.$modal.show('dialog', {
          title: this.$t('playlists.delete.title'),
          text: this.$t('playlists.delete.confirm'),
          buttons: [
            {
              title: this.$t('app.yes'),
              handler: () => {
                this.delete(this.playlist.id).then(() => {
                  this.$toasted.show(this.$t('playlists.delete.success'), {type: 'success'})
                }).catch((e) => {
                  this.$toasted.show(this.error.message, {type: 'error'})
                })
                this.$modal.hide('dialog')
              }
            },
            {
              title: this.$t('app.no'),
              default: true,
              handler: () => {
                this.$modal.hide('dialog')
              }
            }
          ]
        })
      },
      editPlaylist () {
        this.$modal.show('new-playlist-modal', {playlist: this.playlist, picturePath: this.picture})
      },
      sharePlaylist () {
        this.$modal.show('share-modal', {
          link: consts.BASE_HOST + '/services/share/playlist/' + this.playlist.id,
          title: this.playlist.title,
          // playlist de artistname
          description: '',
          playlist: this.playlist
        })
      },
      likePlaylist () {
        this.togglePlaylistLike(this.playlist.id).then(() => {
          this.liking = this.playlistLiked
        }).catch((e) => {
          this.$toasted.show(this.error.message, {type: 'error'})
        })
      }
    },
    mounted () {
      this.liking = this.playlist.liked
    },
    watch: {
      selectedPlaylist () {
        this.$root.$on('togglePlaylistLike', (id) => {
          if (this.playlist.id === id) {
            this.liking = this.selectedPlaylist.liked
          }
        })
      }
    }
  }
</script>

<style scoped lang="scss">
  @import '~@/variables.scss';

  a.artist-info:link, a.artist-info:visited {
    color: #FFFFFF;
    text-decoration: none;
  }

  .artist-card {
    width: 15rem;
    flex-shrink: 0;
    flex-grow: 0;
    transition: all .6s;
  }

  .artist-card-profile {
    width: 12rem !important;
  }

  .center-content {
    line-height: normal;
  }

  .w-79 {
    width: 79%;
  }

  // .resize:hover {
  //   width: 190px;
  //   .image-playlist-container {
  //     width: 190px;
  //     height: 190px;
  //   }
  //   .playlist-card-container{
  //     overflow-x: hidden;
  //     width: 190px;
  //   }
  // }

  .play-pause-icon {
    margin-left: 10px;
  }

  .playlist-card-container{
    overflow-x: hidden;
    width: 156px;
  }

  .image-playlist-container {
    width: 156px;
    height: 150px;
  }

  .minH-316 {
    min-height: 316px;
  }
  .minH-280 {
    min-height: 280px;
  }
  .minH-220 {
    min-height: 220px;
  }
  .like-button{
    background-color: rgb(39, 39, 39);
    border: none;
    text-align: right;
    cursor: pointer;
  }
  .liked {
    color: red;
  }
</style>



// WEBPACK FOOTER //
// src/components/PlaylistProfile/ModalPlaylistCard.vue